
      import PicDownload from './pic-download.vue'
      import type { App, Plugin } from 'vue'

      export const PicDownloadPlugin: Plugin = {
        install(app: App) {
          app.component('PicDownload', PicDownload)
        },
      }
      export { PicDownload }
      